<template>
    <div :class="['info', status == '0' ? 'checkInfo' : '']">
        <div v-if="status == '0'" class="pin-button pin-button-left mr-10" @click="handlePinMessage"
            :title="rowData.isPinned ? '取消收藏' : '收藏消息'">
            <i :class="[
                'el-icon-star-on',
                rowData.isPinned ? 'pinned' : 'unpinned',
            ]"></i>
        </div>
        <!-- <div>消息状态{{ rowData.messageStatus }}</div> -->
        <img v-if="rowData.messageStatus == '0'" class="loading" src="@/assets/loading.gif" alt="" />
        <div v-if="rowData.messageStatus == '2'" class="errorIcon pointer" @click="retryMessage(rowData)">
            !
        </div>
        <!-- <div v-if="rowData.messageStatus == '3'" 
            class="round border-blue flex row center middle mr-10">
            <i class="pd-3 fs-15 el-icon-refresh-right color-blue pointer" style="margin-right: 0.2px;"></i>
        </div> -->
        <!-- 左侧头像 -->
        <div v-if="status == '1'" class="photo-container left">
            <img class="photo left" :src="chatUserInfo.userDetail?.avatar_large
                ? chatUserInfo.userDetail?.avatar_large
                : require('@/assets/profile.png')
                " alt="" />
            <!-- 会员皇冠图标 -->
            <img v-if="chatUserInfo.userDetail?.isVip == 1" class="crown-icon" src="@/assets/icon/vip.png" alt="VIP" />
        </div>
        <div v-if="rowData.type == 'message' || rowData.type == 'system'" class="message" style="position: relative">
            <div v-if="rowData.type == 'system'" class="system-message fs-15 bold">
                系统消息：
            </div>
            <span v-if="rowData.content?.message" v-html="$highlight(rowData.content?.message)"></span>
            <div style="
          border-top: 1px solid rgb(220 220 220);
          padding: 2px 0 0;
          margin-top: 10px;
        " v-if="translatedText" v-html="$highlight(translatedText)"></div>
            <div style="position: absolute; bottom: 0; right: 0">
                <img v-if="!isTranslating" class="pointer w-18 h-18"
                    :src="translatedText ? translatedIcon : untranslatedIcon" alt="" srcset=""
                    @click="handleTranslate(rowData.content?.message)" />
                <img v-else class="pointer rotate360 w-18 h-18" src="@/assets/loading.gif" alt="" srcset="" />
            </div>
        </div>
        <div v-if="rowData.type == 'like_newsfeed_post'" class="like-newsfeed-post">
            <div class="like-header">
                <img class="like-icon" src="@/assets/heart.png" alt="点赞" />
                <span class="like-text">Liked the newsfeed post</span>
            </div>
            <div class="post-content">
                <div class="post-text">{{ rowData.content?.text }}</div>
                <div class="post-images" v-if="rowData.content?.photos && rowData.content?.photos.length > 0">
                    <!-- 单张图片 -->
                    <div v-if="rowData.content.photos.length === 1" class="single-image">
                        <ImagePreview :src="rowData.content.photos[0].url"
                            :preview-src-list="rowData.content.photos.map((photo) => photo.url)"
                            :id="chatUserInfo.platformUserId">
                        </ImagePreview>
                    </div>
                    <!-- 多张图片 -->
                    <div v-else class="images-grid">
                        <template v-for="(photo, idx) in rowData.content.photos.slice(0, 4)">
                            <div v-if="idx < 3 || rowData.content.photos.length <= 4" :key="photo.id"
                                class="image-container">
                                <img :src="photo.url" class="grid-image" @click="previewLikeImages(idx)" alt="" />
                            </div>
                            <div v-else :key="'more-' + photo.id" class="image-container more-mask"
                                @click="previewLikeImages(3)">
                                <img :src="photo.url" class="grid-image img-bg" />
                                <div class="mask-text">
                                    +{{ rowData.content.photos.length - 3 }}
                                </div>
                            </div>
                        </template>
                    </div>
                    <!-- 图片预览组件 -->
                    <ImagePreview v-if="showLikeImagesPreview" :showPreview="false"
                        :src="rowData.content.photos[previewLikeImagesIndex]?.url"
                        :preview-src-list="rowData.content.photos.map((photo) => photo.url)"
                        :current-index="previewLikeImagesIndex" @close="showLikeImagesPreview = false"
                        :id="chatUserInfo.platformUserId" ref="likeImagesPreview" />
                </div>
            </div>
        </div>
        <div v-if="rowData.type == 'audio'" class="voiceMessage" @click="playVoice">
            <div class="voiceDefault" v-if="!playStatus">
                <div v-if="status == '0'" class="timeLang left">
                    <span v-if="isDurationLoading" class="loading-duration">加载中...</span>
                    <span v-else>{{ DurationLang }}″</span>
                </div>
                <img class="icon1" src="@/assets/vioceIcon3.png" alt="" />
                <img class="icon2" src="@/assets/vioceIcon4.png" alt="" />
                <div v-if="status == '1'" class="timeLang right">
                    <span v-if="isDurationLoading" class="loading-duration">加载中...</span>
                    <span v-else>{{ DurationLang }}″</span>
                </div>
            </div>
            <div class="voice" v-else>
                <div v-if="status == '0'" class="timeLang left">
                    <span v-if="isDurationLoading" class="loading-duration">加载中...</span>
                    <span v-else>{{ DurationLang }}″</span>
                </div>
                <img class="icon1" src="@/assets/vioceIcon.png" alt="" />
                <img class="icon2" src="@/assets/vioceIcon2.png" alt="" />
                <div v-if="status == '1'" class="timeLang right">
                    <span v-if="isDurationLoading" class="loading-duration">加载中...</span>
                    <span v-else>{{ DurationLang }}″</span>
                </div>
            </div>
            <video class="voiceVideo" controls style="display: none" src=""></video>
            <!-- 音频查看状态指示器 - 只对自己发送的消息显示 -->
            <div v-if="status == '0'"
                :class="'audio-viewed-indicator ' + (rowData.isAudioViewed ? 'listened' : 'unlistened')">
                <img v-if="rowData.isAudioViewed" src="@/assets/svg/listened.svg" alt="已听" class="listened-icon mr-2" />
                <img v-else src="@/assets/svg/unlistened.svg" alt="未听" class="unlistened-icon mr-2" />
                {{ rowData.isAudioViewed ? '已听' : '未听' }}
            </div>
        </div>
        <!-- photo类型且有文字时，使用卡片式布局 -->
        <div v-if="rowData.type == 'photo' && rowData.content?.text" class="photo-with-text-card">
            <div class="photo-container-in-card">
                <ImagePreview :src="rowData.content?.url" :preview-src-list="[rowData.content?.url]"
                    :id="chatUserInfo.platformUserId">
                </ImagePreview>
            </div>
            <div class="photo-text-content" style="position: relative">
                <div class="photo-text">{{ rowData.content.text }}</div>
                <div style="
                    border-top: 1px solid rgb(220 220 220);
                    padding: 2px 0 0;
                    margin-top: 10px;
                " v-if="photoTextTranslatedText" v-html="$highlight(photoTextTranslatedText)"></div>
                <div style="position: absolute; bottom: 0; right: 0">
                    <img v-if="!isPhotoTextTranslating" class="pointer w-18 h-18"
                        :src="photoTextTranslatedText ? translatedIcon : untranslatedIcon" alt="" srcset=""
                        @click="handlePhotoTextTranslate(rowData.content.text)" />
                    <img v-else class="pointer rotate360 w-18 h-18" src="@/assets/loading.gif" alt="" srcset="" />
                </div>
            </div>
        </div>
        <!-- 其他类型的图片消息保持原样 -->
        <div v-else-if="
            rowData.type == 'likephoto' ||
            rowData.type == 'wink' ||
            rowData.type == 'sticker'
        " :class="[
            rowData.type == 'wink' || rowData.type == 'sticker'
                ? 'smallImgWrapper'
                : 'onceImgWrapper',
        ]">
            <div :class="[
                'messageImg',
                rowData.type == 'wink' || rowData.type == 'sticker'
                    ? 'smallImg'
                    : 'onceImg',
            ]">
                <!-- <img class="imgs" :src="rowData.imgUrl" alt=""> -->
                <template v-if="isTsEmoji">
                    <div class="tsEmoji animated-sprite" :style="'background-image: url(' + rowData.imgUrl + ')'"></div>
                </template>
                <template v-else>
                    <!-- <img class="w-100 h-100" :src="rowData.imgUrl" alt="" @dblclick="previewEmoji(rowData)"> -->
                    <template v-if="rowData.type == 'wink'">
                        <ImagePreview :src="require('@/assets/icon/Winked.png')"
                            :preview-src-list="[require('@/assets/icon/Winked.png')]">
                        </ImagePreview>
                    </template>
                    <template v-else-if="rowData.type == 'likephoto'">
                        <ImagePreview :src="rowData.content?.url" :preview-src-list="[rowData.content?.url]"
                            :id="chatUserInfo.platformUserId">
                        </ImagePreview>
                        <div class="giftName" style="display: flex; align-items: center">
                            <img class="like-icon" src="@/assets/heart.png" alt="点赞" />喜欢您的照片
                        </div>
                    </template>
                    <template v-else>
                        <ImagePreview :src="rowData.content?.url" :preview-src-list="[rowData.content?.url]"
                            :id="chatUserInfo.platformUserId">
                        </ImagePreview>
                    </template>
                </template>
            </div>
        </div>
        <!-- photo类型但无文字时，使用普通图片显示 -->
        <div v-else-if="rowData.type == 'photo'" class="messageImg onceImg">
            <ImagePreview :src="rowData.content?.url" :preview-src-list="[rowData.content?.url]"
                :id="chatUserInfo.platformUserId">
            </ImagePreview>
        </div>
        <div v-else-if="rowData.type == 'virtual_gift'" class="giftMessage flex col" style="position: relative">
            <ImagePreview class="flex row center" :src="rowData.content?.imageSrc"
                :preview-src-list="[rowData.content?.imageSrc]" :id="chatUserInfo.platformUserId">
            </ImagePreview>
            <div v-if="rowData.content?.message" style="position: relative">
                <div>{{ rowData.content?.message }}</div>
                <div style="
            border-top: 1px solid rgb(220 220 220);
            padding: 2px 0 0;
            margin-top: 10px;
          " v-if="giftMessageTranslatedText" v-html="$highlight(giftMessageTranslatedText)"></div>
                <div style="position: absolute; bottom: 0; right: 0">
                    <img v-if="!isGiftMessageTranslating" class="pointer w-18 h-18"
                        :src="giftMessageTranslatedText ? translatedIcon : untranslatedIcon" alt="" srcset=""
                        @click="handleGiftMessageTranslate(rowData.content?.message)" />
                    <img v-else class="pointer rotate360 w-18 h-18" src="@/assets/loading.gif" alt="" srcset="" />
                </div>
            </div>
            <div class="giftTip">送您一个礼物</div>
        </div>
        <template v-if="rowData.type == 'photo_batch'">
            <div v-if="getCombinedMedia(rowData.content).length === 1" class="messageImg br-8 onceImg">
                <div class="media-img-container onceImg">
                    <ImagePreview :src="getCombinedMedia(rowData.content)[0]?.url"
                        :preview-src-list="[getCombinedMedia(rowData.content)[0]?.url]"
                        :id="chatUserInfo.platformUserId" />
                    <img v-if="getCombinedMedia(rowData.content)[0]?.type === 'video'" class="play-icon"
                        src="@/assets/attachment/bfIcon.png" alt="播放" />
                </div>
            </div>
            <div class="messagesImg" v-else>
                <div :class="['img-grid', status == '0' ? 'align-right' : 'align-left']">
                    <div v-for="(item, idx) in getCombinedMedia(rowData.content)" :key="idx"
                        class="media-img-container">
                        <img :src="item.url" class="grid-img" @click="previewBatch(idx)" alt="" />
                        <img v-if="item.type === 'video'" class="play-icon" src="@/assets/attachment/bfIcon.png"
                            alt="播放" />
                    </div>
                </div>
                <ImagePreview v-if="showBatchPreview" :showPreview="false"
                    :src="getCombinedMedia(rowData.content)[previewBatchIndex]?.url" :preview-src-list="getCombinedMedia(rowData.content).map((item) => item.url)
                        " :current-index="previewBatchIndex" @close="showBatchPreview = false"
                    :id="chatUserInfo.platformUserId" ref="batchPreview" />
            </div>
        </template>
        <template v-if="rowData.type == 'post'">
            <div class="post-card">
                <div class="media-grid">
                    <!-- 合并照片和视频，按顺序显示 -->
                    <template v-for="(item, idx) in getCombinedMedia(rowData.content).slice(
                        0,
                        4
                    )">
                        <div v-if="idx < 3 || getCombinedMedia(rowData.content).length <= 4" :key="item.id"
                            class="media-img-container">
                            <img :src="item.url" class="media-img" />
                            <img v-if="item.type === 'video'" class="play-icon" src="@/assets/attachment/bfIcon.png"
                                alt="播放" />
                        </div>
                        <div v-else :key="'more-' + item.id" class="media-img more-mask" @click="
                            handlePreviewMore(getCombinedMedia(rowData.content), 3, 'url')
                            ">
                            <img :src="item.url" class="img-bg" />
                            <img v-if="item.type === 'video'" class="play-icon" src="@/assets/attachment/bfIcon.png"
                                alt="播放" />
                            <div class="mask-text">
                                +{{ getCombinedMedia(rowData.content).length - 3 }}
                            </div>
                        </div>
                    </template>
                </div>
                <div class="post-summary">{{ rowData.content.textPreview }}</div>
                <el-button class="view-post-btn" type="primary" size="medium" @click="onViewPost(rowData)">⚡ View
                    post</el-button>
                <div class="post-status">
                    <el-tag v-if="rowData.content.isPurchased" type="success" size="mini">已浏览</el-tag>
                    <el-tag v-else type="info" size="mini">未浏览</el-tag>
                </div>
            </div>
        </template>
        <template v-if="rowData.type == 'reply_newsfeed_post'">
            <div class="post-card">
                <div class="fs-20 bold mt-4 mb-14">回复了帖子</div>
                <div class="media-grid">
                    <!-- 合并照片和视频，按顺序显示 -->
                    <template v-for="(item, idx) in getCombinedMedia(rowData.content).slice(
                        0,
                        4
                    )">
                        <div v-if="idx < 3 || getCombinedMedia(rowData.content).length <= 4" :key="item.id"
                            class="media-img-container">
                            <img :src="item.url" class="media-img" />
                            <img v-if="item.type === 'video'" class="play-icon" src="@/assets/attachment/bfIcon.png"
                                alt="播放" />
                        </div>
                        <div v-else :key="'more-' + item.id" class="media-img more-mask" @click="
                            handlePreviewMore(getCombinedMedia(rowData.content), 3, 'url')
                            ">
                            <img :src="item.url" class="img-bg" />
                            <img v-if="item.type === 'video'" class="play-icon" src="@/assets/attachment/bfIcon.png"
                                alt="播放" />
                            <div class="mask-text">
                                +{{ getCombinedMedia(rowData.content).length - 3 }}
                            </div>
                        </div>
                    </template>
                </div>
                <div class="post-summary">{{ rowData.content.text }}</div>
                <div v-if="rowData.content.replyText" class="replyTip" style="position: relative">
                    <div>{{ rowData.content.replyText }}</div>
                <div style="
            border-top: 1px solid rgb(220 220 220);
            padding: 2px 0 0;
            margin-top: 10px;
          " v-if="replyTextTranslatedText" v-html="$highlight(replyTextTranslatedText)"></div>
                <div style="position: absolute; bottom: 0; right: 0">
                    <img v-if="!isReplyTextTranslating" class="pointer w-18 h-18"
                        :src="replyTextTranslatedText ? translatedIcon : untranslatedIcon" alt="" srcset=""
                        @click="handleReplyTextTranslate(rowData.content.replyText)" />
                    <img v-else class="pointer rotate360 w-18 h-18" src="@/assets/loading.gif" alt="" srcset="" />
                </div>
                </div>
            </div>
        </template>
        <div class="messageVideo" v-if="rowData.type == 'video'">
            <!-- <div class="videoBox" @click="getVideo(rowData)">
                <img class="videoImg" :src="rowData.content?.url" alt="">
                <img class="bfIcon" src="@/assets/attachment/bfIcon.png" alt="">
            </div> -->
            <VideoPreview :videoId="Number(rowData.content?.id)" :coverSrc="rowData.content?.url" :show-preview="false"
                ref="videoPreview"></VideoPreview>
            <div class="flex row middle media-tagSec ml-4 mb-8" style="margin-top: -30px" v-if="rowData.isVideoViewed">
                <img :src="rowData.isVideoViewed ? require('@/assets/see.png') : require('@/assets/unsee.png')" alt="已看"
                    class="listened-icon w-18" />
            </div>
        </div>
        <template v-if="type == '5'">
            <div class="emailMessage" v-if="rowData.emailSubject || rowData.emailText" style="position: relative">
                <!-- <video class="imgs" :src="rowData.imgUrl" alt=""> -->
                <!--  @click="copy(rowData.emailSubject)" -->
                <div class="title" v-html="$highlight(rowData.emailSubject)"></div>
                <div class="text" v-html="$highlight(rowData.emailText)"></div>
                <div style="
            border-top: 1px solid rgb(220 220 220);
            padding: 2px 0 0;
            margin-top: 10px;
          " v-if="translatedText">
                    <div style="padding: 2px 0 0; word-break: break-all" v-html="$highlight(translatedText)"></div>
                </div>
                <div style="position: absolute; bottom: 0; right: 0">
                    <img v-if="!isTranslating" class="pointer w-18 h-18"
                        :src="translatedText ? translatedIcon : untranslatedIcon" alt="" srcset="" @click="
                            handleTranslate(`${rowData.emailSubject}\r\n${rowData.emailText}`)
                            " />
                    <img v-else class="pointer rotate360 w-18 h-18" src="@/assets/loading.gif" alt="" srcset="" />
                </div>
                <div class="filesAttached" @click="lookFile(rowData)">
                    {{ rowData.msgFiles?.length || 0 }} 附加文件
                </div>
                <div class="fileList" v-if="rowData.fileShow && rowData.msgFiles?.length > 0">
                    <div class="file" v-for="(item, index) in rowData.msgFiles" :key="index"
                        @click="previewImage(item)">
                        <img class="viewImage" v-if="item.fileType == 'photo'" :src="item.fileUrl" alt="" srcset="" />
                        <video class="viewImage" v-if="item.fileType == 'video'" :src="item.fileUrl" alt=""
                            srcset=""></video>
                        <!-- <audio :src="item.fileUrl" controls v-if="item.fileType == 'audio'"></audio> -->
                        <div class="audioBox" v-if="item.fileType == 'audio'">
                            <img class="suspendIcon" src="@/assets/suspendIcon.png" alt="" srcset="" />
                            <img class="soundWaveIcon" src="@/assets/soundWaveIcon.png" alt="" srcset="" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="message" style="position: relative">
                <span v-if="rowData.message" v-html="$highlight(rowData.message)"></span>
                <!-- 翻译功能已隐藏，保留代码以便后续恢复 -->
                <!-- <div style="
            border-top: 1px solid rgb(220 220 220);
            padding: 2px 0 0;
            margin-top: 10px;
          " v-if="translatedText" v-html="$highlight(translatedText)"></div>
                <div style="position: absolute; bottom: 0; right: 0">
                    <img v-if="!isTranslating" class="pointer w-18 h-18"
                        :src="translatedText ? translatedIcon : untranslatedIcon" alt="" srcset=""
                        @click="handleTranslate(rowData.message)" />
                    <img v-else class="pointer rotate360 w-18 h-18" src="@/assets/loading.gif" alt="" srcset="" />
                </div> -->
            </div>
        </template>

        <!-- 右侧头像 -->
        <div v-if="status == '0'" class="photo-container right">
            <img class="photo right" :src="chatUserInfo.platformUserDetail?.avatar_small
                ? chatUserInfo.platformUserDetail?.avatar_small
                : require('@/assets/profile.png')
                " alt="" />
            <!-- 会员皇冠图标 -->
            <img v-if="chatUserInfo.platformUserDetail?.isVip == 1" class="crown-icon" src="@/assets/icon/vip.png"
                alt="VIP" />
        </div>
        <div :class="[
            'time',
            status == '0' ? 'timePositionRight' : 'timePositionLeft',
        ]">
            <i v-if="rowData.isPinned" class="el-icon-star-on" style="color: #ffd043; font-size: 16px"></i>
            <!-- style="display: flex;align-items: center;" -->
            {{ timestampToCurrentTime(rowData.dateCreated) }}
            <!-- <div class="del" @click="delFun(rowData)">
                <img src="@/assets/icon/scIcon.png" alt="" srcset="" style="width: 15px;height: 15px;margin-left: 10px;">
            </div> -->
        </div>

        <!-- 收藏消息按钮 -->
        <div v-if="status != '0'" class="pin-button pin-button-right ml-10" @click="handlePinMessage"
            :title="rowData.isPinned ? '取消收藏' : '收藏消息'">
            <i :class="[
                'el-icon-star-on',
                rowData.isPinned ? 'pinned' : 'unpinned',
            ]"></i>
        </div>
        <el-dialog title="" :modal="true" class="emailDialog" :visible.sync="viewShow" width="600px"
            :before-close="handleClose">
            <img class="viewImage" v-if="fileInfo.fileType == 'photo'" :src="fileInfo.fileUrl" alt="" srcset="" />
            <video class="viewImage" controls v-if="fileInfo.fileType == 'video'" :src="fileInfo.fileUrl" alt=""
                srcset=""></video>
            <audio :src="fileInfo.fileUrl" controls v-if="fileInfo.fileType == 'audio'"></audio>
        </el-dialog>

        <!-- 帖子详情弹窗 -->
        <PostDetail :visible="showPostDetail" :post="detailPost" @close="showPostDetail = false"
            @preview-more="handlePostPreviewMore" />
    </div>
</template>

<script>
import dayjs from 'dayjs';
import { delChat } from '@/api/dialogue';
// 静态变量，用于跟踪当前正在播放的音频
let currentPlayingAudio = null;
import { translateText, DeepSeekStreamTranslator } from '@/api/deepseekApi'; // 导入封装的API方法
import { generateYoudaoSignedParams, translate } from '@/api/youdaoSign';
import { getMessageTranslationProvider } from '@/utils/translationSettings';
import { union } from 'lodash';
import axios from 'axios';
import ImagePreview from '@/components/imagePreview.vue';
import VideoPreview from '@/components/videoPreview.vue';
import PostDetail from '../../postView/detail.vue';
import {
    getDialogPost,
    pinMessage,
    unpinMessage,
} from '@/api/talkytimes/message';
export default {
    props: {
        // status: {
        //     type: String,
        //     default: '0'  // 0左 1右
        // },
        // status: {
        //     type: String,
        //     default: '0'  // 0左 1右
        // },
        type: {
            type: String,
            default: '0', // 0文字  1语音 2图片
        },
        message: {
            type: String,
            default: '',
        },
        rowData: {
            type: Object,
            // default: () => { }
        },
        chatUserInfo: {
            type: Object,
            // default: () => { }
        },
    },
    components: {
        ImagePreview,
        VideoPreview,
        PostDetail,
    },
    data() {
        return {
            timeLang: 0,
            playStatus: false, // 语音播放状态 true 播放中 false 未播放
            DurationLang: 0,
            isDurationLoading: false, // 音频时长加载状态
            fileInfo: {},
            viewShow: false,
            isTsEmoji: false,
            translatedText: '',
            isTranslating: false, // 是否正在翻译
            // 礼物消息翻译相关
            giftMessageTranslatedText: '',
            isGiftMessageTranslating: false,
            // 回复文本翻译相关
            replyTextTranslatedText: '',
            isReplyTextTranslating: false,
            // 照片文本翻译相关
            photoTextTranslatedText: '',
            isPhotoTextTranslating: false,
            // 预加载翻译图标
            translatedIcon: require('@/assets/icon/yFy.png'),
            untranslatedIcon: require('@/assets/icon/nFy.png'),
            status: '0',
            showBatchPreview: false,
            previewBatchIndex: 0,
            // 帖子详情弹窗相关
            showPostDetail: false,
            detailPost: {},
            // 点赞图片预览相关
            showLikeImagesPreview: false,
            previewLikeImagesIndex: 0,
        };
    },
    watch: {
        rowData: {
            handler(newVal) {
                // console.log('newVal：：：', newVal.idUserFrom, this.chatUserInfo.platformUserId, this.chatUserInfo.userId)
                if (!newVal) return;
                if (newVal.idUserFrom == this.chatUserInfo.platformUserId) {
                    this.status = '0';
                } else if (newVal.idUserFrom == this.chatUserInfo.userId) {
                    this.status = '1';
                } else {
                    console.log(
                        '不属于当前聊天的消息',
                        newVal,
                        newVal.idUserFrom,
                        newVal.idUserTo
                    );
                }
                this.rowData = newVal;
                // 重置翻译状态
                this.translatedText = '';
                this.giftMessageTranslatedText = '';
                this.replyTextTranslatedText = '';
                this.photoTextTranslatedText = '';
                if (newVal.type == 'audio' && newVal.content) {
                    // 优先使用content中的duration字段，如果没有则通过加载音频获取
                    if (newVal.content.duration && newVal.content.duration > 0) {
                        this.DurationLang = newVal.content.duration;
                        this.isDurationLoading = false;
                    } else {
                        const fileUrl = newVal.content.urlMp3;
                        // 创建Audio对象获取音频时长
                        const audio = new Audio();

                        // 设置跨域属性
                        audio.crossOrigin = 'anonymous';

                        // 开始加载时长
                        this.isDurationLoading = true;
                        this.DurationLang = 0;

                        // 添加错误处理
                        audio.addEventListener('error', (e) => {
                            // console.error('音频加载失败:', e);
                            this.DurationLang = 0;
                            this.isDurationLoading = false;
                        });

                        // 使用多个事件确保获取到时长
                        const getDuration = () => {
                            if (
                                audio.duration &&
                                isFinite(audio.duration) &&
                                audio.duration > 0
                            ) {
                                // console.log('audio.duration：：：', audio.duration);
                                this.DurationLang = Math.round(audio.duration);
                                this.isDurationLoading = false;
                                // 获取成功后移除事件监听
                                audio.removeEventListener('loadedmetadata', getDuration);
                                audio.removeEventListener('canplay', getDuration);
                                audio.removeEventListener('loadeddata', getDuration);
                            }
                        };

                        audio.addEventListener('loadedmetadata', getDuration);
                        audio.addEventListener('canplay', getDuration);
                        audio.addEventListener('loadeddata', getDuration);

                        // 设置超时处理
                        setTimeout(() => {
                            if (this.isDurationLoading) {
                                // console.warn('音频时长获取超时，尝试直接获取');
                                if (
                                    audio.duration &&
                                    isFinite(audio.duration) &&
                                    audio.duration > 0
                                ) {
                                    this.DurationLang = Math.round(audio.duration);
                                }
                                this.isDurationLoading = false;
                            }
                        }, 5000);

                        audio.src = fileUrl;
                    }
                }
                if (newVal.imgUrl && newVal.imgUrl.includes('monstro')) {
                    this.isTsEmoji = true;
                } else {
                    this.isTsEmoji = false;
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        retryMessage(rowData) {
            this.$emit('retryMessage', rowData);
        },
        previewEmoji(item) {
            console.log('previewEmoji:', item);
            this.fileInfo = {
                fileType: 'photo',
                fileUrl: item.imgUrl,
            };
            this.viewShow = true;
        },
        // startTranslation
        async handleTranslate(v) {
            if (this.translatedText) {
                return;
            }
            let languages = this.detectLanguage(v),
                fromLang = '',
                toLang = '';
            console.log(languages, 111);
            if (languages == 'zh') {
                fromLang = 'zh';
                toLang = 'en';
            } else {
                fromLang = languages;
                toLang = 'zh';
            }
            this.isTranslating = true;

            try {
                const translation = await translate(v, 'auto', toLang, {
                    provider: getMessageTranslationProvider(),
                });
                this.translatedText = translation;
                console.log(translation);
            } catch (err) {
                this.error = err.message;
            } finally {
                this.isTranslating = false;
            }
        },
        // 礼物消息翻译
        async handleGiftMessageTranslate(v) {
            if (this.giftMessageTranslatedText) {
                return;
            }
            let languages = this.detectLanguage(v),
                fromLang = '',
                toLang = '';
            console.log(languages, 111);
            if (languages == 'zh') {
                fromLang = 'zh';
                toLang = 'en';
            } else {
                fromLang = languages;
                toLang = 'zh';
            }
            this.isGiftMessageTranslating = true;

            try {
                const translation = await translate(v, 'auto', toLang, {
                    provider: getMessageTranslationProvider(),
                });
                this.giftMessageTranslatedText = translation;
                console.log(translation);
            } catch (err) {
                this.error = err.message;
            } finally {
                this.isGiftMessageTranslating = false;
            }
        },
        // 回复文本翻译
        async handleReplyTextTranslate(v) {
            if (this.replyTextTranslatedText) {
                return;
            }
            let languages = this.detectLanguage(v),
                fromLang = '',
                toLang = '';
            console.log(languages, 111);
            if (languages == 'zh') {
                fromLang = 'zh';
                toLang = 'en';
            } else {
                fromLang = languages;
                toLang = 'zh';
            }
            this.isReplyTextTranslating = true;

            try {
                const translation = await translate(v, 'auto', toLang, {
                    provider: getMessageTranslationProvider(),
                });
                this.replyTextTranslatedText = translation;
                console.log(translation);
            } catch (err) {
                this.error = err.message;
            } finally {
                this.isReplyTextTranslating = false;
            }
        },
        // 照片文本翻译
        async handlePhotoTextTranslate(v) {
            if (this.photoTextTranslatedText) {
                return;
            }
            let languages = this.detectLanguage(v),
                fromLang = '',
                toLang = '';
            console.log(languages, 111);
            if (languages == 'zh') {
                fromLang = 'zh';
                toLang = 'en';
            } else {
                fromLang = languages;
                toLang = 'zh';
            }
            this.isPhotoTextTranslating = true;

            try {
                const translation = await translate(v, 'auto', toLang, {
                    provider: getMessageTranslationProvider(),
                });
                this.photoTextTranslatedText = translation;
                console.log(translation);
            } catch (err) {
                this.error = err.message;
            } finally {
                this.isPhotoTextTranslating = false;
            }
        },
        detectLanguage(text) {
            if (!text || !text.trim()) return 'unknown';

            // 定义各语言的正则表达式
            const languagePatterns = {
                zh: /[\u4e00-\u9fa5]/, // 中文
                en: /[a-zA-Z]/, // 英文
                th: /[\u0E00-\u0E7F]/, // 泰语
                ja: /[\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF]/, // 日语(平假名+片假名+汉字)
                ko: /[\uAC00-\uD7AF]/, // 韩语
                ru: /[\u0400-\u04FF\u0500-\u052F]/, // 俄语
                fr: /[éèêëçàâûîôùÉÈÊËÇÀÂÛÎÔÙ]/, // 法语
            };

            // 计算有效字符总数（排除空格和标点符号）
            const validChars = text.replace(/[\s\p{P}]/gu, '');
            const totalLength = validChars.length;

            // 统计各语言字符数量和计算占比
            const charCounts = {};
            const percentages = {};

            for (const [lang, regex] of Object.entries(languagePatterns)) {
                const matches = validChars.match(new RegExp(regex.source, 'g')) || [];
                charCounts[lang] = matches.length;
                percentages[lang] = (matches.length / totalLength) * 100;
            }

            // 特殊处理日语和中文的汉字重叠问题
            if (percentages.ja > 0 && percentages.zh > 0) {
                const japaneseKana = text.match(/[\u3040-\u309F\u30A0-\u30FF]/g) || [];
                if (japaneseKana.length > 0) {
                    // 如果有平假名/片假名，增加日语的权重
                    percentages.ja += (japaneseKana.length / totalLength) * 100;
                } else {
                    // 如果没有平假名/片假名，则认为是中文
                    percentages.ja = 0;
                }
            }

            // 设置语言判断阈值（百分比）
            const THRESHOLD = 60; // 主导语言需要超过60%
            const MINIMUM_THRESHOLD = 30; // 次要语言至少需要30%才考虑

            // 找出占比最高的语言
            let dominantLang = 'unknown';
            let maxPercentage = 0;

            for (const [lang, percentage] of Object.entries(percentages)) {
                if (percentage > maxPercentage) {
                    maxPercentage = percentage;
                    dominantLang = lang;
                }
            }

            // 如果最高占比的语言超过阈值，则认为是该语言
            if (maxPercentage >= THRESHOLD) {
                return dominantLang;
            }

            // 如果英文占比超过MINIMUM_THRESHOLD，优先判定为英文
            if (percentages.en >= MINIMUM_THRESHOLD) {
                return 'en';
            }

            // 如果没有明显主导语言，但有多种语言混合
            if (maxPercentage > MINIMUM_THRESHOLD) {
                return dominantLang;
            }

            return 'unknown';
        },
        copy(v) {
            console.log(v);
            const textarea = document.createElement('textarea');
            textarea.value = v;
            textarea.style.position = 'fixed'; // 防止页面滚动
            document.body.appendChild(textarea);

            // 选中文本
            textarea.select();

            try {
                // 执行复制命令
                const successful = document.execCommand('copy');
                const msg = successful ? '成功复制到剪贴板' : '复制失败';
                this.$message.success(msg); // 使用Element UI的消息提示
            } catch (err) {
                this.$message.error('复制失败: ' + err);
            }

            // 移除临时元素
            document.body.removeChild(textarea);
        },
        playVoice() {
            // 如果有其他音频正在播放，先停止它
            if (currentPlayingAudio && currentPlayingAudio !== this) {
                currentPlayingAudio.stopAudio();
            }

            const audio = document.querySelector('.voiceVideo');
            // 修复：使用正确的音频URL路径
            const audioUrl =
                this.rowData.content?.urlMp3 || this.rowData.content?.urlOgg;
            if (!audioUrl) {
                console.error('音频URL不存在');
                return;
            }
            audio.src = audioUrl;

            if (this.playStatus) {
                audio.pause(); // 暂停播放
                currentPlayingAudio = null;
            } else {
                audio.play().catch((error) => {
                    console.error('音频播放失败:', error);
                    this.playStatus = false;
                });
                // 设置当前实例为正在播放的音频
                currentPlayingAudio = this;

                // 添加播放结束事件监听器
                audio.addEventListener(
                    'ended',
                    () => {
                        this.playStatus = false;
                        currentPlayingAudio = null;
                    },
                    { once: true }
                ); // 使用once选项确保监听器只触发一次
            }
            this.playStatus = !this.playStatus;
        },
        lookFile(rowData) {
            this.$set(this.rowData, 'fileShow', !rowData.fileShow);
        },
        handleClose() {
            this.viewShow = false;
            this.fileInfo = {};
        },
        previewImage(item) {
            console.log(item);
            return;
            this.fileInfo = item;
            this.viewShow = true;
        },
        previewBatch(idx) {
            this.previewBatchIndex = idx;
            this.showBatchPreview = true;
            // this.$refs.batchPreview.openPreview();
            this.$nextTick(() => {
                this.$refs.batchPreview.openPreview();
            });
        },
        // 添加一个方法用于停止当前音频播放
        stopAudio() {
            const audio = document.querySelector('.voiceVideo');
            audio.pause();
            this.playStatus = false;
        },
        timestampToCurrentTime(timestamp) {
            let time = dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
            return time;
        },
        handlePreviewMore(list, index, field) {
            // 这里可调用全局图片预览逻辑
            // 例如 this.$emit('preview', {list, index, field}) 或弹窗
            // 这里只做示例
            this.$emit('preview', { list, index, field });
        },
        getCombinedMedia(content) {
            const photos = (content.photos || []).map((photo) => ({
                ...photo,
                type: 'photo',
            }));
            const videos = (content.videos || []).map((video) => ({
                ...video,
                type: 'video',
            }));
            return [...photos, ...videos];
        },
        onViewPost(rowData) {
            console.log('onViewPost', rowData);
            const idPost = rowData.content.idPost;
            this.detailPost = {};
            getDialogPost({
                idPost: Number(idPost),
                idInterlocutor: Number(
                    rowData.idUserFrom == this.chatUserInfo.platformUserId
                        ? this.chatUserInfo.userId
                        : this.chatUserInfo.platformUserId
                ),
            }).then((res) => {
                console.log('帖子详情:', res);
                this.detailPost = res;
            });
            this.showPostDetail = true;
        },
        // 处理帖子详情弹窗中的图片预览
        handlePostPreviewMore(params) {
            if (params && typeof params === 'object' && params.list) {
                const { list, index } = params;
                this.$emit('preview', { list, index, field: 'url' });
            }
        },
        // 预览点赞图片
        previewLikeImages(index) {
            this.previewLikeImagesIndex = index;
            this.showLikeImagesPreview = true;
            // 手动触发预览模态框
            this.$nextTick(() => {
                if (this.$refs.likeImagesPreview) {
                    this.$refs.likeImagesPreview.openPreview();
                }
            });
        },

        // 处理收藏消息
        async handlePinMessage() {
            try {
                if (this.rowData.isPinned) {
                    // 取消收藏
                    await unpinMessage({ idMessage: this.rowData.id });
                    this.$set(this.rowData, 'isPinned', false);
                    this.$message.success('已取消收藏');
                    // 通知父组件收藏状态改变
                    this.$emit('pin-status-changed', {
                        messageId: this.rowData.id,
                        isPinned: false,
                    });
                } else {
                    // 收藏消息
                    await pinMessage({ idMessage: this.rowData.id });
                    this.$set(this.rowData, 'isPinned', true);
                    this.$message.success('已收藏消息');
                    // 通知父组件收藏状态改变
                    this.$emit('pin-status-changed', {
                        messageId: this.rowData.id,
                        isPinned: true,
                    });
                }
            } catch (error) {
                console.error('收藏操作失败:', error);
                this.$message.error('操作失败，请重试');
            }
        },
    },
    created() {
        // 初始化翻译器（API Key 建议从环境变量读取）
        this.translator = new DeepSeekStreamTranslator(
            'sk-3f002abeeecd4f1ebb97c234fe9166dc'
        );
    },
    beforeDestroy() {
        // 组件销毁时中止未完成的请求
        this.translator?.abort();
    },
    mounted() { },
};
</script>
<style lang="scss" scoped>
.info {
    display: flex;
    position: relative;
    margin-bottom: 40px;
    align-items: start;

    .photo-container {
        position: relative;

        .photo {
            width: 44px;
            height: 44px;
            margin-top: 6.5px;
            border-radius: 50%;
        }
    }

    .left {
        margin-right: 10px;

        .crown-icon {
            position: absolute;
            top: -4px;
            right: 0;
            width: 18px;
            height: 18px;
            z-index: 10;
        }
    }

    .right {
        margin-left: 10px;
        margin-right: 4px;

        .crown-icon {
            position: absolute;
            top: -4px;
            right: -4px;
            width: 18px;
            height: 18px;
            z-index: 10;
        }
    }

    .message {
        max-width: 448px;
        box-sizing: border-box;
        padding: 18px 20px;
        border-radius: 20px;
        background-color: #f7f9fa;
        line-height: 22px;
        letter-spacing: 0.5px;
        /* 确保元素是可选的 */
        user-select: text;
        word-break: break-all;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
    }

    .emailMessage {
        max-width: 600px;
        box-sizing: border-box;
        padding: 18px 20px;
        border-radius: 20px;
        background-color: #f7f9fa;
        line-height: 22px;
        letter-spacing: 0.5px;

        .title {
            font-weight: 500;
            font-size: 16px;
            // color: #333333;
            margin-bottom: 10px;
            /* 确保元素是可选的 */
            user-select: text;
            -webkit-user-select: text;
            -moz-user-select: text;
            -ms-user-select: text;
        }

        .text {
            font-weight: 400;
            font-size: 14px;
            // color: #666666;
            margin-bottom: 10px;
            /* 确保元素是可选的 */
            user-select: text;
            -webkit-user-select: text;
            -moz-user-select: text;
            -ms-user-select: text;
        }

        .filesAttached {
            background: #eee;
            border-radius: 8px;
            width: 100px;
            font-size: 12px !important;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }

        .fileList {
            display: flex;
            margin-top: 10px;
            flex-wrap: wrap;
            gap: 10px;

            img {
                width: 100px;
                height: 100px;
                border-radius: 10px;
            }

            video {
                width: 100px;
                height: 100px;
                border-radius: 10px;
            }
        }
    }

    .voiceMessage {
        background-color: #f7f9fa;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        padding: 18px 20px;

        .voiceDefault {
            display: flex;
            min-width: 100px;
            height: 40px;
            align-items: center;
            cursor: pointer;
            color: #333333;

            .icon1 {
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }

            .icon2 {
                width: 34px;
                height: 26px;
            }

            .timeLang {
                font-weight: 400;
                font-size: 18px;

                .loading-duration {
                    color: #999;
                    font-size: 14px;
                    /* 动画已移除 */
                }
            }
        }

        .voice {
            display: flex;
            min-width: 100px;
            height: 40px;
            align-items: center;
            cursor: pointer;
            color: #ff8c3f;

            .icon1 {
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }

            .icon2 {
                width: 34px;
                height: 26px;
            }

            .timeLang {
                font-weight: 400;
                font-size: 18px;

                .loading-duration {
                    color: #999;
                    font-size: 14px;
                    /* 动画已移除 */
                }
            }
        }
    }

    .messageImg {
        width: 100px;
        // height: 94px;

        .imgs {
            width: 100%;
            height: 100%;
        }
    }

    .giftMessage {
        width: 400px;
        // height: 94px;
    }

    .smallImgWrapper {
        display: flex;
        flex-direction: column;
    }

    .onceImgWrapper {
        display: flex;
        flex-direction: column;
    }

    .photo-text-message {
        max-width: 448px;
        box-sizing: border-box;
        padding: 18px 20px;
        margin-top: 8px;
        border-radius: 20px;
        background-color: #f7f9fa;
        line-height: 22px;
        letter-spacing: 0.5px;
        user-select: text;
        word-break: break-all;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
    }

    .photo-with-text-card {
        background: #fff;
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
        padding: 12px;
        margin-bottom: 12px;
        max-width: 300px;
        display: flex;
        flex-direction: column;
    }

    .photo-container-in-card {
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 8px;
    }

    .photo-container-in-card img {
        width: 100%;
        height: auto;
        border-radius: 8px;
        display: block;
    }

    .photo-text-content {
        padding: 0;
    }

    .photo-text {
        font-size: 13px;
        color: #2c3e50;
        word-break: break-all;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        line-clamp: 3;
        overflow: hidden;
        font-weight: 500;
        line-height: 1.5;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        user-select: text;
        -webkit-user-select: text;
        -moz-user-select: text;
        -ms-user-select: text;
    }

    .messagesImg {
        display: flex;
        justify-content: flex-end;
    }

    .img-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        max-width: 270px;
        /* 调整最大宽度以适应3个图片：3 * 80px + 2 * 6px = 252px */
    }

    .img-grid.align-right {
        justify-content: flex-end;
    }

    .img-grid.align-left {
        justify-content: flex-start;
    }

    .grid-img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 8px;
        flex-shrink: 0;
        /* 防止图片被压缩 */
    }

    .messageVideo {
        width: 100%;
        max-width: 200px;
        position: relative;

        .videoBox {
            width: 100%;
            position: relative;
            overflow: hidden;
        }

        .videoImg {
            width: 100%;
            display: block;
            object-fit: cover;
            aspect-ratio: 1 / 1; // 保持正方形
        }

        .bfIcon {
            position: absolute;
            z-index: 10;
            width: 50px;
            height: 50px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            pointer-events: none;
        }
    }

    .time {
        position: absolute;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
    }

    .timePositionLeft {
        bottom: -24px;
        left: 54px;
        flex-direction: row-reverse;
    }

    .timePositionRight {
        bottom: -24px;
        right: 54px;
    }
}

.checkInfo {
    justify-content: end;
}

.loading {
    width: 20px;
    height: 20px;
    margin: 0 10px;
    animation: rotate 2s linear infinite;
    /* 动画名称、持续时间、速度曲线和循环次数 */
}

@keyframes rotate {
    from {
        transform: rotate(0deg);
        /* 起始角度 */
    }

    to {
        transform: rotate(360deg);
        /* 结束角度 */
    }
}

.errorIcon {
    background: red;
    // padding: 10px;
    width: 18px;
    height: 18px;
    text-align: center;
    color: white;
    border-radius: 50%;
    margin-right: 10px;
}

.audioBox {
    width: 100px;
    height: 100px;
    background: #f7f9fa;
    overflow: hidden;
    border-radius: 6px;

    .suspendIcon {
        width: 30px !important;
        height: 30px !important;
        margin: auto;
        margin-top: 30px;
    }

    .soundWaveIcon {
        width: 56px !important;
        height: 20px !important;
        margin: auto;
        margin-top: 10px;
    }
}

.viewImage {
    width: 500px;
    // margin: auto;
    max-height: 500px;
}

.tsEmoji {
    width: 100px;
    /* 单个帧的宽度 */
    height: 100px;
    /* 单个帧的高度 */
    /* 精灵图的路径 */
    background-repeat: no-repeat;
    background-size: 3200px 100px;
}

@keyframes spriteAnimation {
    0% {
        background-position: 0 0;
    }

    100% {
        background-position: -3200px 0;
    }

    /* 回到第一帧 */
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }
}

.post-card {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    padding: 12px 12px 8px 12px;
    margin-bottom: 12px;
    max-width: 340px;
}

.media-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 6px;
    margin-bottom: 8px;
}

.media-img-container {
    position: relative;
    width: 100%;
    height: 167px;
    border-radius: 6px;
    overflow: hidden;
}

.media-img,
.more-mask {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
    position: relative;
    overflow: hidden;
}

.play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 24px;
    height: 24px;
    z-index: 2;
    pointer-events: none;
}

.img-grid .media-img-container {
    position: relative;
    display: block;
    width: 80px;
    height: 80px;
}

.more-mask {
    cursor: pointer;
}

.img-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.6);
}

.mask-text {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 1.4em;
    font-weight: 700;
    background: linear-gradient(135deg,
            rgba(0, 0, 0, 0.6) 0%,
            rgba(0, 0, 0, 0.4) 100%);
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    letter-spacing: 1px;
    backdrop-filter: blur(2px);
}

    .post-summary {
    font-size: 13px;
    color: #2c3e50;
    margin-bottom: 8px;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
        line-clamp: 2;
    overflow: hidden;
    font-weight: 500;
    line-height: 1.5;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.view-post-btn {
    width: 100%;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 14px;
    height: 34px;
    padding: 0;
}

.post-status {
    text-align: left;

    .el-tag {
        margin-top: 2px;
        font-size: 12px;
        padding: 0 8px;
        height: 22px;
        line-height: 20px;
        border-radius: 10px;
    }
}

.giftName {
    position: absolute;
    bottom: -7px;
    // left: 55px;
    font-size: 13px;
    font-weight: 600;
    color: #2c3e50;
    margin-top: 4px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    letter-spacing: 0.5px;
    padding: 4px 8px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.95);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.giftTip {
    font-size: 15px;
    font-weight: 700;
    color: #8b5cf6;
    margin-top: 8px;
    margin-bottom: 10px;
    letter-spacing: 0.8px;
    padding: 8px 16px;
    background: rgba(139, 92, 246, 0.12);
    border-left: 4px solid #8b5cf6;
    position: relative;
    display: inline-flex;
    align-items: center;
    border-radius: 0 6px 6px 0;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(139, 92, 246, 0.15);
}

.giftTip::before {
    content: '🎁';
    margin-right: 10px;
    font-size: 18px;
    opacity: 0.9;
}

.replyTip {
    font-size: 15px;
    font-weight: 700;
    color: #333;
    margin-top: 8px;
    margin-bottom: 10px;
    letter-spacing: 0.8px;
    padding: 8px 16px;
    background: rgba(175, 173, 173, 0.1);
    border-left: 4px solid #aaa;
    position: relative;
    display: inline-flex;
    align-items: center;
    border-radius: 0 6px 6px 0;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(102, 102, 102, 0.15);
    width: 100%;
    box-sizing: border-box;
}

.onceImg {
    width: 200px !important;
    height: 200px !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.smallImg {
    width: 80px !important;
    height: 80px !important;
    display: flex;
    justify-content: center;
    align-items: center;
}

.like-newsfeed-post {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    padding: 12px;
    margin-bottom: 12px;
    max-width: 200px;
}

.like-header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.like-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
}

.like-text {
    font-size: 14px;
    font-weight: 600;
    color: #2c3e50;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.post-content {
    margin-top: 8px;
}

    .post-text {
    font-size: 13px;
    color: #2c3e50;
    margin-bottom: 8px;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
        line-clamp: 2;
    overflow: hidden;
    font-weight: 500;
    line-height: 1.5;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.post-images {
    margin-top: 8px;
}

.single-image {
    border-radius: 8px;
    overflow: hidden;
    max-width: 100%;
}

.single-image img {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

.images-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 80px;
    gap: 4px;
    margin-top: 8px;
}

.image-container {
    position: relative;
    width: 100%;
    height: 80px;
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;
}

.grid-image {
    width: 100%;
    height: 80px;
    object-fit: cover;
    border-radius: 6px;
}

.image-container.more-mask {
    cursor: pointer;
}

.image-container.more-mask .img-bg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: brightness(0.6);
}

/* 收藏按钮样式 */
.pin-button {
    cursor: pointer;
    padding: 4px;
    border-radius: 50%;
    transition: all 0.3s ease;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    align-self: center;
    opacity: 0;
    visibility: hidden;
    transform: scale(0.8);
    flex-shrink: 0;
}

/* hover 时显示收藏按钮 */
.info:hover .pin-button {
    opacity: 1;
    visibility: visible;
    transform: scale(1);
}

/* 确保按钮在消息容器内正确显示 */
.info {
    position: relative;
}

.info .message,
.info .emailMessage,
.info .voiceMessage,
.info .messageImg,
.info .messagesImg,
.info .messageVideo,
.info .post-card,
.info .like-newsfeed-post {
    position: relative;
}

.pin-button .el-icon-star-on {
    font-size: 18px;
    transition: all 0.3s ease;
}

.pin-button .el-icon-star-on.pinned {
    color: #ffd043;
}

.pin-button .el-icon-star-on.unpinned {
    color: #c0c4cc;
}

/* 音频查看状态指示器样式 */
.audio-viewed-indicator {
    position: absolute;
    bottom: 0;
    left: 0;
    color: #4a4a4a;
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    padding: 1px 6px;
    display: flex;
    align-items: center;
    font-size: 11px;
    z-index: 10;

    &.listened {
        background-color: #e8f5e8;
    }

    &.unlistened {
        background-color: #ffeeeb;
    }

    .listened-icon,
    .unlistened-icon {
        width: 12px;
        height: 12px;
    }
}

.pin-button:hover .el-icon-star-on.unpinned {
    color: #ffd043;
}

.media-tagSec {
    position: relative;
    background: #ffffffcc;
    color: white;
    width: 26px;
    height: 26px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
